//const BASE_URL = 'http://localhost:3001'; // Update with your backend URL
const BASE_URL = 'https://sam.huntersolutionsltd.com:3001/api'; // Update with your backend URL
//
export default BASE_URL;